import { invokeApi } from "../bl_libs/invokeApi";

export const get_home_dashboard_api = async (data = {}) => {
  const requestObj = {
    path: `api/partner/home_dashboard`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
